import React, { useEffect, useState } from 'react';
import {
  Button,
  Chip,
  Badge,
  Card,
  Typography,
  Accordion,
  Grid,
  AccordionSummary,
  AccordionDetails,
  Box,
  TextField,
} from '@mui/material';
import './LeaveStatusCard.css';
import { DialogBoxComponent } from '../DialogBox/DialogBoxCard';
import CalendarMonthRoundedIcon from '@mui/icons-material/CalendarMonthRounded';
import {
  LeaveStatusType,
  CANCEL_BUTTON_TEXT,
  LeaveStatusButton,
  SHOW_NOTIFICATION,
} from '../../constants';
import { useLocation } from 'react-router-dom';
import { withStyles } from '@mui/styles';
import ShowLeaveStatus from './LeaveStatus';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { applyLeave } from '../../services/LeaveService';
import moment from 'moment';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import FlakyOutlinedIcon from '@mui/icons-material/FlakyOutlined';
import { useDispatch, useSelector } from 'react-redux';
import { leaveType } from '../../pages/Leaves/LeavesConstants';
import KeycloakService from '../../services/KeycloakService';
import { getUserData } from '../../services/UserService';
import {
  formatCasualLeaveBandLabel,
  isCasualLeaveName,
} from '../../utils/casualLeaveUtils';

const LeaveStatusCardComponent = (props) => {
  const {
    leave,
    leaveStatus,
    toggleEditOpen,
    updateApplication,
    getLeaveList,
    setPage,
    setPageNo,
    setRefresh,
    refresh,
    updateApplicationByHr,
    variant,
  } = props;
  const [officeLocationId, setOfficeLocationId] = useState();
  const [open, setOpen] = React.useState(false);
  const location = useLocation();
  // Manager approve context: explicit variant (Senior Manager Leave) or legacy Manage path
  const isManagerView =
    variant === 'manager' || location.pathname === '/user-manage';
  const [expanded, setExpanded] = React.useState(false);
  const [rows, setRows] = React.useState([]);
  const [loader, setLoader] = React.useState(false);
  const [dialogContent, setDialogContent] = React.useState();
  const [confirmText, setConfirmText] = React.useState();
  const [comment, setComment] = React.useState();
  const dispatch = useDispatch();

  const cardState = useSelector((state) => state.cardState);

  useEffect(() => {
    loadData();
    setExpanded(cardState.expand);
  }, [cardState]);

  const dipatchNotification = (typ, msg) => {
    dispatch({
      type: SHOW_NOTIFICATION,
      data: {
        open: true,
        type: typ,
        message: msg,
      },
    });
  };

  const disableRescheduleForRejected = (leave) => {
    return (
      leave.status == 'REJECTED' &&
      moment(leave.startDate).isBefore(
        moment(
          new Date(
            new Date().getFullYear(),
            new Date().getMonth() - 2,
            new Date().getDate(),
          ).setHours(0, 0, 0, 0),
        ),
      )
    );
  };

  const getLeaveRange = () => {
    let startDate;
    let endDate;

    if (!isManagerView) {
      startDate = leave.startDate;
      endDate = leave.endDate;
    } else {
      startDate = leave.applicationDTO.startDate;
      endDate = leave.applicationDTO.endDate;
    }
    if (startDate === endDate) {
      return <>{moment(startDate).format('DD MMM YYYY')}</>;
    } else {
      return (
        <>
          {moment(startDate).format('DD MMM YYYY')} to{' '}
          {moment(endDate).format('DD MMM YYYY')}
        </>
      );
    }
  };

  const handleClose = () => {
    setComment(null);
    setOpen(false);
  };

  const handleCommentChange = (event) => {
    setComment(event.target.value);
  };

  const isDuplicate = (leave) => {
    const j = leave.applicationStatusDTOS.length;
    for (let i = 0; i < j; i++) {
      if (leave.applicationStatusDTOS[i].approverId == currentUserId()) {
        return leave.applicationStatusDTOS[i].id;
      }
    }
    return '';
  };

  const handleOnConfirm = () => {
    let templateApplicationResponse;
    if (isManagerView) {
      templateApplicationResponse = {
        applicationDTO: {
          type: leave.applicationDTO.type,
          id: leave.applicationDTO.id,
          employeeId: leave.applicationDTO.employeeId,
          startDate: leave.applicationDTO.startDate,
          endDate: leave.applicationDTO.endDate,
          reason: leave.applicationDTO.reason,
          status: leave.applicationDTO.status,
          isUpdatedByAdmin: leave.applicationDTO.isUpdatedByAdmin,
          isUpdatedByHr: false,
          leaveId: leave.applicationDTO.leaveId,
        },
        id: leave.id,
        status: ' ',
        comments: !comment ? 'No comments' : comment,
        approverId: currentUserId(),
        type: leave.type,
      };
      if (confirmText === 'Reject') {
        templateApplicationResponse = {
          ...templateApplicationResponse,
          status: 'REJECTED',
        };
      } else if (confirmText === 'Approve') {
        templateApplicationResponse = {
          ...templateApplicationResponse,
          status: 'APPROVED',
        };
      }
    } else if (location.pathname === '/hr-WFH') {
      templateApplicationResponse = {
        applicationDTO: {
          type: leave.type,
          id: leave.id,
          employeeId: leave.employeeId,
          startDate: leave.startDate,
          endDate: leave.endDate,
          reason: leave.reason,
          status: leave.status,
          isUpdatedByAdmin: leave.isUpdatedByAdmin,
          isUpdatedByHr: true,
        },
        comments: !comment ? 'No comments' : comment,
        status: '',
        approverId: currentUserId(),
        type: leave.type,
        id: isDuplicate(leave) ? isDuplicate(leave) : '',
      };
      if (confirmText === 'Reject') {
        templateApplicationResponse = {
          ...templateApplicationResponse,
          applicationDTO: {
            ...templateApplicationResponse.applicationDTO,
            status: 'REJECTED',
          },
          status: 'REJECTED',
        };
      } else if (confirmText === 'Approve') {
        templateApplicationResponse = {
          ...templateApplicationResponse,
          applicationDTO: {
            ...templateApplicationResponse.applicationDTO,
            status: 'APPROVED',
          },
          status: 'APPROVED',
        };
      }
    } else {
      templateApplicationResponse = {
        applicationDTO: {
          type: leave.type,
          id: leave.id,
          employeeId: leave.employeeId,
          startDate: leave.startDate,
          endDate: leave.endDate,
          reason: leave.reason,
          status: leave.status,
          isUpdatedByAdmin: leave.isUpdatedByAdmin,
          isUpdatedByHr: true,
          leaveId: leave.leaveId,
        },
        comments: !comment ? 'No comments' : comment,
        status: '',
        type: leave.type,
        approverId: currentUserId(),
        id: isDuplicate(leave) ? isDuplicate(leave) : '',
      };
      if (confirmText === 'Reject') {
        templateApplicationResponse = {
          ...templateApplicationResponse,
          status: 'REJECTED',
        };
      } else if (confirmText === 'Approve') {
        templateApplicationResponse = {
          ...templateApplicationResponse,
          status: 'APPROVED',
        };
      }
    }

    isManagerView
      ? updateApplication(templateApplicationResponse)
      : updateApplicationByHr(templateApplicationResponse);
    setComment(null);
    setOpen(false);
  };

  const cancelLeavePayload = () => {
    return {
      id: leave.id,
      employeeId: currentUserId(),
      status: 'CANCELLED',
      leaveId: leave.leaveId,
    };
  };
  const currentUserId = () => KeycloakService.getUserDetail();
  const loadData = async () => {
    const user = await getUserData(currentUserId());
    if (user.data.locationId) {
      setOfficeLocationId(user.data.locationId);
    }
  };
  const cancelLeave = async () => {
    const cancelledLeavePayload = cancelLeavePayload();
    const leaveResponse = await applyLeave(
      cancelledLeavePayload,
      officeLocationId,
    );
    dipatchNotification(leaveResponse.type, leaveResponse.message);
    if (leaveResponse.isError === false) {
      setOpen(false);

      setRefresh(!refresh);
    }
  };

  const StyledBadge = withStyles((theme) => ({
    badge: {
      backgroundColor: '#b35900',
      color: 'white',
    },
  }))(Badge);

  const utilization = leave?.casualLeaveUtilization;
  // Band/CL chips only for employees currently in a Leave Group (quarterly accounting).
  const showCasualLeaveUtilization =
    utilization != null &&
    utilization.casualLeaveAccountingEnabled === true &&
    isCasualLeaveName(leave?.leaveType);
  const bandLabel = showCasualLeaveUtilization
    ? formatCasualLeaveBandLabel(utilization?.casualLeaveBand)
    : null;
  const previousBandLabel = showCasualLeaveUtilization
    ? formatCasualLeaveBandLabel(utilization?.previousQuarterCasualLeaveBand)
    : null;

  return (
    <div>
      {loader ? (
        <Stack>
          <Typography variant="h1">
            {<Skeleton sx={{ height: '9rem' }} />}
          </Typography>
        </Stack>
      ) : (
        <Card variant="outlined" sx={{ mb: 2 }}>
          <div className="leave-status-container pb-0">
            <div className="space-between-container">
              <Typography sx={{ width: '30%' }} variant="h6">
                {!isManagerView &&
                location.pathname !== '/hr-leaves' &&
                location.pathname !== '/hr-WFH'
                  ? leave.leaveType
                  : leave.empName}
              </Typography>
              <Typography sx={{ width: '40%', textAlign: 'center' }}>
                <CalendarMonthRoundedIcon
                  fontSize="small"
                  className="mr-1 mt-n1"
                />
                {getLeaveRange()}
              </Typography>
              <Box sx={{ width: '30%', textAlign: 'right' }}>
                {isManagerView || location.pathname === '/hr-leaves' ? (
                  <Chip
                    sx={{ marginRight: 1.5 }}
                    label={leave.leaveType}
                    color="secondary"
                    size="small"
                    variant="outlined"
                  />
                ) : (
                  ''
                )}
                <Chip
                  label={leaveStatus}
                  color={
                    leaveStatus === LeaveStatusType.APPROVED
                      ? 'success'
                      : leaveStatus === LeaveStatusType.REJECTED
                        ? 'error'
                        : 'warning'
                  }
                  size="small"
                  variant="outlined"
                />
              </Box>
            </div>
            {isManagerView ||
            location.pathname === '/hr-leaves' ||
            location.pathname === '/hr-WFH' ? (
              <Box
                sx={{
                  display: 'flex',
                  marginTop: 1,
                  marginRight: { xs: 0, md: 3 },
                  justifyContent: 'center',
                  marginBottom: 2,
                  width: '100%',
                  flexDirection: { xs: 'column', md: 'row', sm: 'column' },
                }}
              >
                <Chip
                  label={
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        marginBottom: '2px',
                      }}
                    >
                      <Box sx={{ marginRight: '20px' }}>
                        <Typography variant="body3">
                          {leave?.type === 'WFH' ? 'WFH' : 'Leaves'} taken in
                          Year :
                        </Typography>
                      </Box>
                      <StyledBadge
                        badgeContent={leave?.ytdLeavesTaken?.toString()}
                        sx={{ marginRight: '10px' }}
                      />
                    </Box>
                  }
                  size="small"
                  sx={{
                    color: '#663300',
                    height: '30px',
                    marginRight: { xs: 0, md: 5 },
                    marginBottom: { xs: 1, md: 0 },
                  }}
                  variant="outlined"
                />
                <Chip
                  label={
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        marginBottom: '2px',
                      }}
                    >
                      <Box sx={{ marginRight: '20px' }}>
                        <Typography variant="body3">
                          {leave?.type === 'WFH' ? 'WFH' : 'Leaves'} taken in
                          Quarter :
                        </Typography>
                      </Box>
                      <StyledBadge
                        badgeContent={leave?.qtdLeavesTaken?.toString()}
                        sx={{ marginRight: '10px' }}
                      />
                    </Box>
                  }
                  size="small"
                  sx={{
                    color: '#663300',
                    height: '30px',
                    marginRight: { xs: 0, md: 5 },
                    marginBottom: { xs: 1, md: 0 },
                  }}
                  variant="outlined"
                />
                <Chip
                  label={
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        marginBottom: '2px',
                      }}
                    >
                      <Box sx={{ marginRight: '20px' }}>
                        <Typography variant="body3">
                          {leave?.type === 'WFH' ? 'WFH' : 'Leaves'} taken in
                          Month :
                        </Typography>
                      </Box>
                      <StyledBadge
                        badgeContent={leave?.mtdLeavesTaken?.toString()}
                        sx={{ marginRight: '10px' }}
                      />
                    </Box>
                  }
                  size="small"
                  sx={{
                    color: '#663300',
                    height: '30px',
                    marginRight: {
                      xs: 0,
                      md: showCasualLeaveUtilization && bandLabel ? 5 : 0,
                    },
                    marginBottom: { xs: 1, md: 0 },
                  }}
                  variant="outlined"
                />
                {showCasualLeaveUtilization && bandLabel ? (
                  <Chip
                    label={
                      <Typography variant="body3">
                        Current Band : {bandLabel}
                      </Typography>
                    }
                    size="small"
                    sx={{
                      color: '#663300',
                      height: '30px',
                      marginRight: {
                        xs: 0,
                        md: previousBandLabel ? 5 : 0,
                      },
                      marginBottom: { xs: 1, md: 0 },
                    }}
                    variant="outlined"
                  />
                ) : null}
                {showCasualLeaveUtilization && previousBandLabel ? (
                  <Chip
                    label={
                      <Typography variant="body3">
                        Prev Quarter Band : {previousBandLabel}
                      </Typography>
                    }
                    size="small"
                    sx={{
                      color: '#663300',
                      height: '30px',
                      marginRight: { xs: 0, md: 0 },
                      marginBottom: { xs: 1, md: 0 },
                    }}
                    variant="outlined"
                  />
                ) : null}
              </Box>
            ) : (
              ''
            )}
            <div className="flex-center-container">
              <div className="space-between-container">
                <DialogBoxComponent
                  open={open}
                  handleClose={handleClose}
                  confirmText={confirmText}
                  cancelText={'Close'}
                  content={dialogContent}
                  onConfirm={
                    confirmText == 'Confirm' ? cancelLeave : handleOnConfirm
                  }
                  onCancel={handleClose}
                  component={
                    confirmText == 'Confirm' ? null : (
                      <TextField
                        sx={{ marginLeft: '10px', marginRight: '10px' }}
                        id="outlined-multiline-static"
                        label="Comment"
                        multiline
                        rows={4}
                        value={comment}
                        onChange={handleCommentChange}
                      />
                    )
                  }
                  icon={<FlakyOutlinedIcon color="primary" />}
                />
                {isManagerView ? (
                  <>
                    {leave.leaveCategoryId == 1 && (
                      <>
                        <Button
                          variant="outlined"
                          size="small"
                          color="error"
                          sx={{ px: 3 }}
                          disabled={
                            (leave.applicationDTO.isUpdatedByAdmin &&
                              !KeycloakService.hasRole(['hr'])) ||
                            leave.status == 'REJECTED'
                          }
                          hidden={leave.applicationDTO.status == 'CANCELLED'}
                          onClick={() => {
                            setOpen(true);
                            setConfirmText('Reject');
                            setDialogContent(
                              'Are you sure, you want to reject this application?',
                            );
                          }}
                        >
                          {leave.status == 'REJECTED'
                            ? LeaveStatusButton.REJECTED
                            : LeaveStatusButton.REJECT}
                        </Button>

                        <div className="leaves-spacer"></div>
                        <Button
                          variant="outlined"
                          size="small"
                          color="success"
                          sx={{ px: 3 }}
                          disabled={
                            (leave.applicationDTO.isUpdatedByAdmin &&
                              !KeycloakService.hasRole(['hr'])) ||
                            leave.status == 'APPROVED'
                          }
                          hidden={leave.applicationDTO.status == 'CANCELLED'}
                          onClick={() => {
                            setOpen(true);
                            setConfirmText('Approve');
                            setDialogContent(
                              'Are you sure, you want to approve this application?',
                            );
                          }}
                        >
                          {leave.status == 'APPROVED'
                            ? LeaveStatusButton.APPROVED
                            : LeaveStatusButton.APPROVE}
                        </Button>
                      </>
                    )}
                  </>
                ) : location.pathname === '/hr-leaves' ||
                  location.pathname === '/hr-WFH' ? (
                  <>
                    <Button
                      variant="outlined"
                      size="small"
                      color="error"
                      sx={{ px: 3 }}
                      hidden={leave.status == 'CANCELLED'}
                      disabled={leave.status == 'REJECTED'}
                      onClick={() => {
                        setOpen(true);
                        setConfirmText('Reject');
                        setDialogContent(
                          'Are you sure, you want to reject this application?',
                        );
                      }}
                    >
                      {leave.status == 'REJECTED'
                        ? LeaveStatusButton.REJECTED
                        : LeaveStatusButton.REJECT}
                    </Button>
                    <div className="leaves-spacer"></div>
                    <Button
                      variant="outlined"
                      size="small"
                      color="success"
                      sx={{ px: 3 }}
                      hidden={leave.status == 'CANCELLED'}
                      disabled={leave.status == 'APPROVED'}
                      onClick={() => {
                        setOpen(true);
                        setConfirmText('Approve');
                        setDialogContent(
                          'Are you sure, you want to approve this application?',
                        );
                      }}
                    >
                      {leave.status == 'APPROVED'
                        ? LeaveStatusButton.APPROVED
                        : LeaveStatusButton.APPROVE}
                    </Button>
                  </>
                ) : (
                  <>
                    <div className="space-between-container">
                      <Button
                        variant="outlined"
                        size="small"
                        color="error"
                        sx={{ px: 3 }}
                        disabled={
                          leave.status == 'CANCELLED' ||
                          leave.status === 'REJECTED' ||
                          leave.isUpdatedByAdmin
                        }
                        onClick={() => {
                          setOpen(true);
                          setConfirmText('Confirm');
                          setDialogContent(
                            'Are you sure, you want to cancel this application?',
                          );
                        }}
                      >
                        {CANCEL_BUTTON_TEXT}
                      </Button>
                      <div className="leaves-spacer"></div>
                      <Button
                        variant="outlined"
                        size="small"
                        sx={{ px: 3 }}
                        disabled={
                          moment(leave.startDate).isBefore(
                            moment(
                              new Date(
                                new Date().getFullYear(),
                                new Date().getMonth() - 6,
                                new Date().getDate(),
                              ).setHours(0, 0, 0, 0),
                            ),
                          ) ||
                          disableRescheduleForRejected(leave) ||
                          leave.status == 'CANCELLED' ||
                          leave.status == 'APPROVED' ||
                          leave.isUpdatedByAdmin
                        }
                        onClick={() => {
                          toggleEditOpen(leave);
                        }}
                      >
                        {LeaveStatusButton.RESCHEDULE}
                      </Button>
                    </div>
                  </>
                )}
              </div>
            </div>{' '}
            {isManagerView &&
            leave.applicationDTO.status != 'CANCELLED' &&
            leave.applicationDTO.isUpdatedByAdmin &&
            !KeycloakService.hasRole(['hr']) ? (
              <Typography
                sx={{
                  marginTop: 1,
                  width: '100%',
                  textAlign: 'center',
                  fontSize: '12px',
                }}
              >
                <InfoOutlinedIcon color="info" sx={{ fontSize: '13px' }} />{' '}
                {`Application already ${leave.applicationDTO.status.toLowerCase()} by HR`}
              </Typography>
            ) : (
              ''
            )}
            {location.pathname === '/user-leaves' &&
            leave.status != 'CANCELLED' &&
            leave.isUpdatedByAdmin ? (
              <Typography
                sx={{
                  marginTop: 1,
                  width: '100%',
                  textAlign: 'center',
                  fontSize: '12px',
                }}
              >
                <InfoOutlinedIcon color="info" sx={{ fontSize: '13px' }} />
                {` Please reach out to HR/Admin to modify or cancel`}
              </Typography>
            ) : (
              ''
            )}
            <div>
              <Accordion
                expanded={expanded}
                onChange={() => setExpanded(!expanded)}
                disableGutters
                elevation={0}
                sx={{ width: '100%' }}
              >
                <Grid
                  className="leave-container pb-0 pt-0"
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    height: '25px',
                    alignItems: 'center',
                  }}
                >
                  <AccordionSummary expandIcon={<KeyboardArrowDownIcon />} />
                </Grid>
                <Grid
                  className="leave-container pb-0 pt-0"
                  sx={{ width: '100%' }}
                >
                  <AccordionDetails className="p-0">
                    <Typography variant="body1" className="mt-1 mb-3">
                      {isManagerView
                        ? leave.applicationDTO.reason
                        : leave.reason}
                    </Typography>
                    <Typography
                      variant="body1"
                      className="mt-1 mb-1"
                      color={'#4D6CD9'}
                    >
                      <strong>Approval Status:</strong>
                    </Typography>
                    {expanded &&
                      (isManagerView
                        ? leave.approverList ||
                          leave.applicationDTO?.applicationStatusDTOS ||
                          []
                        : leave.applicationStatusDTOS || []
                      ).map((managerResponse) => (
                        <ShowLeaveStatus
                          managerResponse={managerResponse}
                          key={managerResponse.id}
                          rows={rows}
                          setRows={setRows}
                          closeLeaveStatus={setExpanded}
                        />
                      ))}
                    {}
                  </AccordionDetails>
                </Grid>
              </Accordion>
            </div>
          </div>
        </Card>
      )}
    </div>
  );
};

export default LeaveStatusCardComponent;
